import { axios } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    createReturn(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/returns', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
  }
}